import { getUsePaymentMethodStep, preferencesAreLoaded } from '../brand/brandSelectors';

import { paymentMethodPostConditions, paymentMethodPreConditions } from './paymentMethodStepSelectors';


const paymentMethodStepConfig = {
    component: () => import('./PaymentMethodStep'),
    flow: 'postBuy',
    isReady: state => preferencesAreLoaded(state),
    canLoad: (state, ownProps) => {
        const { submitPath } = ownProps;
        return { isAllowedOrPath: getUsePaymentMethodStep(state) || submitPath };
    },
    preConditions: paymentMethodPreConditions,
    postConditions: paymentMethodPostConditions
};

export default paymentMethodStepConfig;
